export const reducer = (state: any, action: any) => {
  if (!action.field) {
    return { ...state, ...action.item };
  }
  const { field, value } = action;
  return { ...state, [field]: value };
};

export const initialState: { [key: string]: any } = {
  slideshowQueue: {
    name: "slideshowQueue",
    category: "front",
    value: "",
  },
  newsQueue: {
    name: "newsQueue",
    category: "front",
    value: "",
  },
  puffQueue: {
    name: "puffQueue",
    category: "front",
    value: "",
  },
  sectionsQueue: {
    name: "sectionsQueue",
    category: "front",
    value: "",
  },
  mainMenu: {
    name: "mainMenu",
    category: "front",
    value: "",
  },
  headerMenu: {
    name: "headerMenu",
    category: "front",
    value: "",
  },
  footerMenu: {
    name: "footerMenu",
    category: "front",
    value: "",
  },
  collegePage: {
    name: "collegePage",
    category: "front",
    value: "",
  },
  publicDefaultPortfolio: {
    name: "publicDefaultPortfolio",
    category: "front",
    value: "",
  },
  validigDefaultPortfolio: {
    name: "validigDefaultPortfolio",
    category: "validig",
    value: "",
  },
  vocertDefaultHelpBook: {
    name: "vocertDefaultHelpBook",
    category: "vocert",
    value: "",
  },
  vocertCourseMomentBillingMail: {
    name: "vocertCourseMomentBillingMail",
    category: "vocert",
    value: "",
  },
  voadminDefaultHelpBook: {
    name: "voadminDefaultHelpBook",
    category: "voadmin",
    value: "",
  },
};
